export var DynamicDataType;
(function (DynamicDataType) {
    DynamicDataType["CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM"] = "CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM";
    DynamicDataType["CARD_APPLICATION_CRYPTOGRAM_LONG_FORM"] = "CARD_APPLICATION_CRYPTOGRAM_LONG_FORM";
    DynamicDataType["DYNAMIC_CARD_SECURITY_CODE"] = "DYNAMIC_CARD_SECURITY_CODE";
    DynamicDataType["CARDHOLDER_AUTHENTICATION_CRYPTOGRAM"] = "CARDHOLDER_AUTHENTICATION_CRYPTOGRAM";
    DynamicDataType["NONE"] = "NONE";
})(DynamicDataType || (DynamicDataType = {}));
//# sourceMappingURL=DynamicDataType.js.map